function hasErrors(fieldsError) {
  return fieldsError
    ? Object.keys(fieldsError).some(field => fieldsError[field])
    : false;
}

const progresses = {};

progresses.default = [
  {
    title: 'Описание услуги',
    name: 'name',
    completed: false,
    fields: ['name'],
    check: (values, form) => {
      return !hasErrors(form.getFieldsError(['name'])) && values.name
        ? true
        : false;
    },
    getDescription: values => {
      return values.name;
    },
  },
  {
    title: 'Транспортное средство',
    name: 'vehicle',
    fields: ['vehicle'],
    completed: false,
    check: (values, form) => {
      return values.vehicle ? true : false;
    },
    getDescription: (values, props) => {
      return values.vehicle;
    },
    button: false,
  },
  {
    title: 'Монетизация',
    name: 'monetization',
    fields: [
      't2',
      't4',
      't6',
      't7',
      't8',
      't9',
      'sh1',
      'sh2',
      'sh3',
      'kp1t',
      'kp1p',
      'kp2t',
      'kp2p',
      'kp3t',
      'kp3p',
      'kp4t',
      'kp4p',
      'kz1t',
      'kz1p',
      'kz2t',
      'kz2p',
      'kz3t',
      'kz3p',
      'kz4t',
      'kz4p',
    ],
    check: (values, form) => {
      return Object.values(values).some(item => item);
    },
    completed: false,
    // getDescription: values => {
    //   return `Ставка ${values.priceMinute * 60} руб/ч`;
    // },
    button: false,
  },
  {
    title: 'Срок оплаты',
    name: 'payment',
    fields: ['s1'],
    check: (values, form) => {
      return Object.values(values).some(item => item);
    },
    completed: false,
    getDescription: values => {
      return `${values.s1} дн.`;
    },
    button: false,
  },
];

export default progresses;
